import React, { useState } from "react";
import axios from "axios";
import "../Login/Login.css"; // نفس الشكل بتاع login
import Joi from "joi";

export default function BurialRequestForm() {
  const [requestData, setRequestData] = useState({
    name: "",
    burialDate: "",
    graveNumber: "",
  });
  const [errorList, setErrorList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setRequestData({
      ...requestData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const schema = Joi.object({
      name: Joi.string().min(2).required().label("اسم المتوفي"),
      burialDate: Joi.date().required().label("تاريخ الدفن"),
      graveNumber: Joi.number().required().label("رقم المقبرة"),
    });

    return schema.validate(requestData, { abortEarly: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setIsLoading(true);

    const validation = validateForm();
    if (validation.error) {
      setErrorList(validation.error.details);
      setIsLoading(false);
      return;
    }

    try {
      const { data } = await axios.post(
        "https://cemetery-management.vercel.app/api/burial-requests",
        requestData
      );

      setSuccessMessage("تم إرسال الطلب بنجاح، سيتم مراجعته من قبل الإدارة.");
      setRequestData({ name: "", burialDate: "", graveNumber: "" });
    } catch (err) {
      setError("حدث خطأ أثناء إرسال الطلب. حاول مرة أخرى.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>طلب دفن متوفي</h2>

      {successMessage && (
        <div className="alert alert-success my-2">{successMessage}</div>
      )}
      {error && <div className="alert alert-danger my-2">{error}</div>}
      {errorList.map((err, index) => (
        <div key={index} className="alert alert-danger my-2">
          {err.message}
        </div>
      ))}

      <form onSubmit={handleSubmit}>
        <div>
          <label>اسم المتوفي:</label>
          <input
            type="text"
            name="name"
            value={requestData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>تاريخ الدفن:</label>
          <input
            type="date"
            name="burialDate"
            value={requestData.burialDate}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>رقم المقبرة:</label>
          <input
            type="number"
            name="graveNumber"
            value={requestData.graveNumber}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary btn-block mt-3">
          {isLoading ? <i className="fas fa-spinner fa-spin"></i> : "إرسال الطلب"}
        </button>
      </form>
    </div>
  );
}
